import { io } from 'socket.io-client'
import { APP_DATA } from '../data'

const getSocketUrl = () => {
  try {
    return new URL(APP_DATA.apiUrl).origin
  } catch (error) {
    console.error('URL de API no valida para Socket.IO:', error)
    return APP_DATA.apiUrl
  }
}

export const socket = io(getSocketUrl(), {
  withCredentials: true,
  transports: ['websocket'],
  autoConnect: false,
})
